import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTheme } from '../../contexts/ThemeContext';
import { useTranslation } from 'react-i18next';
import { Home } from 'lucide-react';
import { MosqueIcon } from '../common/IslamicIcons';

const NotFoundPage = () => {
  const { isDarkMode } = useTheme();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const bgClass = isDarkMode
    ? 'bg-gradient-to-b from-[var(--bg-dark-from)] to-[var(--bg-dark-via)]'
    : 'bg-gradient-to-b from-[var(--bg-light-from)] to-white';

  return (
    <div className={`min-h-screen flex flex-col items-center justify-center px-6 text-center ${bgClass}`}>
      <div className="mb-6 opacity-30">
        <MosqueIcon size={80} color={isDarkMode ? 'white' : 'var(--p-hex)'} />
      </div>
      <h1 className={`text-6xl font-black mb-3 ${isDarkMode ? 'text-white' : 'text-[var(--p-hex)]'}`}>
        404
      </h1>
      <p className={`text-lg font-semibold mb-2 ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
        Page Not Found
      </p>
      <p className={`text-sm mb-8 ${isDarkMode ? 'text-gray-400' : 'text-gray-400'}`}>
        The page you're looking for doesn't exist or has been moved.
      </p>
      <button
        onClick={() => navigate('/')}
        className="flex items-center gap-2 px-6 py-3 rounded-xl bg-[var(--p-hex)] text-white font-semibold text-sm hover:bg-[var(--p-light-hex)] transition-colors"
      >
        <Home className="w-4 h-4" />
        Go to Home
      </button>
    </div>
  );
};

export default NotFoundPage;
